import { request } from './request'
//查询上次更新时间
export const getContactsAuto = (data: PostContactsAuto) =>
  request('/portal/verify/phish/contacts/auto', {
    params: {
      ...data,
    },
  })

export interface PostContactsAuto {
  domain_id: string
}
export const postContactsAuto = (data: PostContactsAuto) =>
  request('/portal/verify/phish/contacts/auto', {
    method: 'POST',
    data,
  })

//获取邮箱收集的邮箱列表
export interface PostCollect {
  limit: number
  page: number
  name_keyword?: string
  email_keyword?: string
  group_keyword?: string
  domain_id?: string
  start_time?: string
  end_time?: string
}
export const postCollect = (data: PostCollect) =>
  request('/portal/verify/phish/contacts/collect', {
    method: 'post',
    data,
  })

//获取邮箱的收集来源
export interface GetSource {
  target_id: string
}
export const getSource = (data: GetSource) =>
  request('/portal/verify/phish/contacts/collect/source', {
    params: {
      ...data,
    },
  })

// 导出数据
export interface ExportData {
  report_name: string
}
export const exportData = (data: ExportData) =>
  request('/portal/verify/phish/contacts/collect/export', { params: data })
